import CommonDrawerRoute from '../../../ui-component/CommonDrawerRoute';
import ProfileCardLink from './ProfileCardLink';
import { useNavigate } from 'react-router-dom';
import { ProfileCardType } from '../../../models/ProfileCard';

const ProfileCardRoute = () => {
    const navigate = useNavigate();

    return (
        <CommonDrawerRoute onClose={() => navigate(-1)} title="Profile Card Link">
            <ProfileCardLink profileCardType={ProfileCardType.Personal} />
        </CommonDrawerRoute>
    );
};

export default ProfileCardRoute;
